<template>
  <el-form
    ref="formRef"
    :model="formData"
    :rules="rules"
    label-width="120px"
    label-position="right"
  >

    <!-- 基本信息卡片 -->
    <div class="settings-card">
      <div class="card-header">
        <span>{{ $t('message.device.basicInfo') }}</span>
      </div>
      <div class="card-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('message.device.name')" prop="name">
              <el-input v-model="formData.name" />
            </el-form-item>
          </el-col>          
        </el-row>
     
        <el-form-item :label="$t('message.device.company')" prop="company_id">
          <el-tree-select
            v-model="formData.company_id"
            :data="companyTreeData"
            :props="treePropsCompany"
            :placeholder="$t('message.device.selectCompany')"
            check-strictly
            clearable
            filterable
            style="width: 100%"
            :loading="companyLoading"            
            @change="handleCompanyChange"
            :render-after-expand="false"
          >
            <template #default="{ data }">
              <span>{{ data.name }}</span>
            </template>
          </el-tree-select>
        </el-form-item>
        <el-form-item :label="$t('message.device.description')" prop="description">
          <el-input
            v-model="formData.description"
            type="textarea"
            :rows="3"
          />
        </el-form-item>

        <el-form-item :label="$t('message.device.location')" prop="location">
          <el-input v-model="formData.location" />
        </el-form-item>
      </div>
    </div>

    <!-- 联网设置卡片 -->
    <div class="settings-card">
      <div class="card-header">
        <span>{{ $t('message.device.networkSettings') }}</span>
      </div>
      <div class="card-content">
        <el-form-item :label="$t('message.device.gateway')">
          <el-tree-select
            v-model="gatewayListKey"
            :data="gatewayList"
            :props="treeProps"
            :placeholder="$t('message.device.selectGateway')"
            check-strictly
            clearable
            filterable
            style="width: 100%"
             @node-click="handleGatewaySelect" 
            @change="handleGatewayChange"
          />
        </el-form-item>
      </div>
    </div>

 
    <!-- 数据设置卡片 -->
  <div class="settings-card">
    <div class="card-header">
      <span>{{ $t('message.device.dataSettings') }}</span>
    </div>
    <div class="card-content">
      <el-form-item :label="$t('message.device.associatedDeviceTemplate')">
        <span v-if="formData.template_name" class="template-name-display">
          {{ formData.template_name }}
        </span>

        <el-button type="danger" @click="releaseDeviceTemplateBind">
          {{ $t('message.device.delete') }}
        </el-button>

        <el-button type="primary" @click="openTemplateDialog">
          {{ $t('message.device.selectTemplate') }}
        </el-button>
      </el-form-item>

      <!-- 从机配置区域 - 添加滑动条 -->
      <div v-if="formData.template_id" class="slave-config-wrapper">
          <div class="slave-config-container">
              <div class="slave-config-header">
                <span>{{ $t('message.device.slaveConfig') }}</span>
              </div>
              
            <div v-for="(slave, index) in formData.data_sets" :key="slave.slave_id || index" class="slave-config-item">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item :label="$t('message.device.slaveName')">
                      <el-tag :closable="false" type="info">{{ slave.name }}</el-tag>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item 
                      :label="$t('message.device.serialSerialNumber')"                       
                      :prop="'data_sets.' + index + '.serial_id'"                      
                      :rules="rules.slaveConfigSerialId" 
                    >
                      <el-input                         
                        v-model.number="formData.data_sets[index].serial_id" 
                        :placeholder="$t('message.device.inputSerialPort')"
                        
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item 
                      :label="$t('message.device.slaveAddress')" 
                      :prop="'data_sets.' + index + '.slave_address'"
                      :rules="rules.slaveConfigAddress"
                    >
                      <el-input        
                        v-model.number="formData.data_sets[index].slave_address" 
                        :placeholder="$t('message.device.inputSlaveAddress')"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>


    <!-- 模板选择对话框 -->
    <el-dialog
      v-model="templateDialogVisible"
      :title="$t('message.device.selectTemplate')"
      width="70%"
      height="80%"
      :close-on-click-modal="false"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="template-radio-group">
            <div v-for="template in templateList" :key="template.id" class="template-card">
              <el-radio :label="template.id" v-model="selectedTemplate" border size="medium">
                <div class="template-card-content">
                  <div class="template-name">{{ template.name }}</div>
                </div>
              </el-radio>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
            <!-- 右侧详情区域保持不变 -->
            <div v-if="selectedTemplateDetail">
              <el-row>
                <el-col :span="8">
                  <div class="stat-item">
                    <span class="stat-label">{{ $t('message.device.slaveTotal') }}:</span>
                    <span class="stat-value">{{ selectedTemplateDetail.slave_total }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="stat-item">
                    <span class="stat-label">{{ $t('message.device.varTotal') }}:</span>
                    <span class="stat-value">{{ selectedTemplateDetail.var_total }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="stat-item">
                    <span class="stat-label">{{ $t('message.device.collectionType') }}:</span>
                    <span class="stat-value">{{ selectedTemplateDetail.get_type_name }}</span>
                  </div>
                </el-col>
              </el-row>

              <el-table
                :data="selectedTemplateVariables"
                border
                style="width: 100%; margin-top: 20px"
                height="400"
              >
                <el-table-column prop="slave_name" :label="$t('message.device.slave')" width="150" />
                <el-table-column prop="name" :label="$t('message.device.varName')" width="150" />
                <el-table-column prop="data_type_name" :label="$t('message.device.valueType')" width="120" />
              </el-table>
       
              <el-pagination
                v-if="selectedTemplateVariables.length > 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100]"                
                layout="total, sizes, prev, pager, next, jumper"
                v-model:current-page="pagination.currentPage"
                v-model:page-size="pagination.pageSize"        
                :total="pagination.total"
                style="margin-top: 20px;"
              />
            </div>
            <div v-else style="text-align: center; padding: 50px">
              {{ $t('message.device.selectTemplateFirst') }}
            </div>
          </el-col>
      </el-row>

      <template #footer>
        <el-button @click="templateDialogVisible = false">
          {{ $t('message.device.cancel') }}
        </el-button>
        <el-button type="primary" @click="confirmTemplate">
          {{ $t('message.device.confirm') }}
        </el-button>
      </template>
    </el-dialog>

  </el-form>
</template>

<script setup>
import { ref, reactive, watch, onMounted,defineProps,defineExpose,defineEmits } from 'vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { getCompanyTree,getCompanyGatewayTree } from '@/api/CompanyManager'
import { getTemplates, getTemplateDetail,getVarDetail } from '@/api/TemplateManagement'

const { t } = useI18n()

const props = defineProps({
  deviceData: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['submit'])


const formRef = ref()
// 表单数据
const formData = reactive({
  id: 0,
  name: '',
  device_code: '',
  company_id: null,
  company_name: '',
  description: '',
  gateway_id: null,
  gateway_name: '',
  template_id: null,
  template_name: '',
  data_sets:[],
  state: 1,
  location: ''
 // slaveConfigs: []  // 将 slaveConfigs 放入 formData
})

// 验证规则
const rules = reactive({
  name: [
    { required: true, message: t('message.device.nameRequired'), trigger: 'blur' }
  ],  
  company_id: [
    { required: true, message: t('message.device.companyRequired'), trigger: 'change' }
  ],  
  // 从机配置验证规则
  'slaveConfigSerialId': [
    { required: true, message: t('message.device.inputSerialPort'), trigger: 'blur' },
    { pattern: /^\d+$/, message: t('message.device.serialPortMustBeNumber'), trigger: 'blur' }
  ],
  'slaveConfigAddress': [
    { required: true, message: t('message.device.inputSlaveAddress'), trigger: 'blur' },
    { pattern: /^\d+$/, message: t('message.device.slaveAddressMustBeNumber'), trigger: 'blur' }
  ]
})


// 公司树数据
const companyLoading = ref(false)
const companyLoaded = ref(false)
const companyTreeData = ref([])
const treeProps = {
  value: 'key',
  label: 'name',
  children: 'children'
}

const treePropsCompany = {
  value: 'id',
  label: 'name',
  children: 'children'
}

// 网关列表
const gatewayList = ref([])
const gatewayListKey = ref(null)

const selectedGateway =ref()
// 模板相关
const templateDialogVisible = ref(false)
const templateList = ref([])
const selectedTemplate = ref(null)
const selectedTemplateDetail = ref(null)
const selectedTemplateVariables = ref([])
const templateStats = reactive({
  slaveTotal: 0,
  varTotal: 0,
  collectionType: ''
})
const queryCompanyTreeParams = reactive({
  companyId: null      
})
const pagination = reactive({
  template_id: null,
  currentPage: 1,
  pageSize: 10,
  total: 0
})


// 分页大小改变
const handleSizeChange = (val) => {        
  handlePaginationChange('size', val)
}

// 当前页改变
const handleCurrentChange = (val) => {
  handlePaginationChange('page', val)
}

// 统一的分页处理方法
const handlePaginationChange = (type, val) => {
  if (type === 'size') {    
    pagination.pageSize = val
    pagination.currentPage = 1 // 切换每页大小时重置到第一页
  } else if (type === 'page') {     
    pagination.currentPage = val
  }
  
  // 只有当有模板ID时才加载数据
  if (pagination.template_id) {    
    loadTemplateVarDetail(pagination.template_id)
  }
}

const initFormData = async() => {
  Object.assign(formData, props.deviceData)
  

  if (props.deviceData.template_id) {
    loadTemplateStats(props.deviceData.template_id)

    if(props.deviceData.template_id>0)
    {
      const template = await loadTemplateDetail(props.deviceData.template_id)
      // 初始化从机配置
      formData.data_sets =  template.slaveInfos
        .filter((v, i, arr) => arr.findIndex(t => t.slave_id === v.slave_id) === i)
        .map(v => ({
          slave_id: v.slave_id,
          name: v.slave_name,
          serial_id: v.serial_id,
          slave_address: v.slave_address
        }))      
    }  

    /* if (props.deviceData.data_sets) { 
      ElMessage.error(`${props.deviceData.template_id} initFormData11`);
      formData.data_sets = props.deviceData.data_sets      
    } */
  }
  
  // 初始化时设置公司名称
  if (props.deviceData?.company_id) {
    const companyNode = findNode(companyTreeData.value, props.deviceData.company_id)
    if (companyNode) {
      formData.company_name = companyNode.name
    }
  }

   // 初始化时设置网关名称
  if (props.deviceData?.gateway_id) {    
    formData.gateway_id =props.deviceData?.gateway_id    
    gatewayListKey.value = `2_${formData.gateway_id}`
    formData.gateway_name = props.deviceData?.gateway_name
    
     if(gatewayList.value)
     {
        const gateWayNode = findNodeByKeyAndId(gatewayList.value, props.deviceData?.gateway_id)
        if (gateWayNode) {    
          formData.gateway_name = gateWayNode.name
        } 
     }
    
  }

}
 
const findNodeByKeyAndId = (nodes, id) => {    
    for (const node of nodes) {      
      if (node.id === id && node.type === 2) {        
        return node;
      }
      if (node.children) {
        const found = findNodeByKeyAndId(node.children, id);
        if (found) return found;
      }
    }
    return null;
  };     


    const findCompanyName = (id, tree) => {
      for (const node of tree) {
        if (node.id === id) return node.name
        if (node.children) {
          const found = findCompanyName(id, node.children)
          if (found) return found
        }
      }
      return ''
    }
    
    // 在 script setup 中添加
    const findNode = (nodes, id) => {
      for (const node of nodes) {
        if (node.id === id) return node
        if (node.children) {
          const found = findNode(node.children, id)
          if (found) return found
        }
      }
      return null
    }

    const buildTree = (items) => {
      if (items.some(item => item.children)) return items
      
      const map = {}
      const roots = []
      
      items.forEach(item => {
        map[item.id] = { ...item, children: [] }
      })
      
      items.forEach(item => {
        if (item.parent_id && map[item.parent_id]) {
          map[item.parent_id].children.push(map[item.id])
        } else {
          roots.push(map[item.id])
        }
      })
      
      return roots
    }


    const loadCompanyTree = async () => {
          if (companyLoaded.value) return              

          try {
            companyLoading.value = true
            const res = await getCompanyTree(queryCompanyTreeParams)
            companyTreeData.value = buildTree(res.data.list)
                   
            // 初始化时设置公司名称
            if (props.deviceData?.company_id) {
              const companyNode = findNode(companyTreeData.value, props.deviceData.company_id)
              if (companyNode) {
                formData.company_name = companyNode.name
              }
            }            
            companyLoaded.value = true
          } catch (error) {
            ElMessage.error(error.message || 'Failed to load company tree')
          } finally {
            companyLoading.value = false
          }
        }


    const handleCompanyChange = (value) => { 
      const selectedCompany = findNode(companyTreeData.value, value); 
      if (selectedCompany) {
        formData.company_id = value;
        formData.company_name = selectedCompany.name;
      } else {
        formData.company_id = null;
        formData.company_name = '';    
      }
    };

// 加载网关列表
const loadGateways = async () => {
  try {
    const res = await getCompanyGatewayTree(queryCompanyTreeParams)
    gatewayList.value = res.data.list
  } catch (error) {
    ElMessage.error(error.message || t('message.device.loadGatewaysFailed'))
  }
}

/*   const findNodeByKey = (nodes, targetKey) => {
    for (const node of nodes) {
      if (node.key === targetKey) {
        return node;
      }
      if (node.children) {
        const found = findNodeByKey(node.children, targetKey);
        if (found) return found;
      }
    }
    return null;
  };     */

  const handleGatewaySelect = (node) => {    
      // 如果节点被禁用，直接返回
    if (node.type !== 2) {
      return
    }
     selectedGateway.value = node;
    if(node.type===2)
    {
       formData.gateway_id = node.id;
       formData.gateway_name = node.name;
      gatewayListKey.value = node.key;
    }
    
}

const handleGatewayChange = (value) => {  
  
  if (selectedGateway.value && selectedGateway.value.type === 2) {
    formData.gateway_id = selectedGateway.value.id;
    formData.gateway_name = selectedGateway.value.name;     
    gatewayListKey.value = value;
  } else {    
     // 如果选择的是禁用节点，清空选择
    gatewayListKey.value = null;
    formData.gateway_id = null;
    formData.gateway_name = '';    
  }
};

// 加载模板列表
const loadTemplates = async () => {
  try {    
        const params = {
                          companyId: formData.company_id,
                          name: null,
                          page: 1,
                          size: 30
                        }
                        
    const res = await getTemplates(params)
    
    templateList.value = res.data.list

    
    // 如果模板列表有数据，默认选中第一个模板
    if (templateList.value.length > 0) {
      selectedTemplate.value = templateList.value[0].id;
      await loadTemplateDetail(selectedTemplate.value);
    }

  } catch (error) {
    ElMessage.error(error.message || t('message.device.loadTemplatesFailed'))
  }
}

// 打开模板选择对话框
const openTemplateDialog = async () => {
  if (!formData.company_id) {
    ElMessage.warning(t('message.device.selectCompanyFirst'))
    return
  }
  await loadTemplates()
  templateDialogVisible.value = true
}
//解析模板与设备的绑定
// 解除设备模板绑定
const releaseDeviceTemplateBind = async () => {
  try {
    // 清空模板相关数据
    formData.template_id = null
    formData.template_name = ''
    formData.data_sets = []
 
    // 清空统计信息
    templateStats.slaveTotal = 0
    templateStats.varTotal = 0
    templateStats.collectionType = ''    
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error(t('message.device.unbindFailed'))
    }
  }
}

// 优化后的加载变量详情方法
const loadTemplateVarDetail = async (templateId) => {
  if (!templateId) return []

  try {
    const params = {
      templateId,
      name: null,
      pageNum: pagination.currentPage,
      pageSize: pagination.pageSize
    }

    const res = await getVarDetail(params)
    const data = res.data?.list || []
    const total = res.data?.totalCount || 0
    
    // 更新数据
    selectedTemplateVariables.value = data
    pagination.total = total
    
    return data
  } catch (error) {
    ElMessage.error({
      message: t('message.device.loadTemplateVarFailed'),
      description: error.message
    })
    return []
  }
}

// 加载模板详情
const loadTemplateDetail = async (templateId) => {
  try {
    const params = {
      templateId: templateId,
      name: null,
      page: 1,
      size: 1000//pagination.pageSize
    }    
    pagination.currentPage = 1
    pagination.template_id = templateId

    const res = await getTemplateDetail(params)    
    // 使用可选链和空值合并运算符简化代码
    const templateDetail = res.data.list ?? null    
    // 更新响应式数据
    selectedTemplateDetail.value = templateDetail
     
    selectedTemplateVariables.value =  await loadTemplateVarDetail(templateId)
    
    return templateDetail

  } catch (error) {    
    ElMessage.error({
      message: t('message.device.loadTemplateFailed'),
      description: error.message
    })
    return null
  }
}
 

// 加载模板统计信息
const loadTemplateStats = async (templateId) => {
  const detail = await loadTemplateDetail(templateId)
  if (detail) {
    templateStats.slaveTotal = detail.slave_total || 0
    templateStats.varTotal = detail.var_total || 0
    templateStats.collectionType = detail.get_type_name || ''
  }
}


// 修改confirmTemplate方法
const confirmTemplate = async () => {  
    
  if (!selectedTemplate.value) {
    ElMessage.warning(t('message.device.selectTemplateFirst'))
    return
  }

  const detail = await loadTemplateDetail(selectedTemplate.value)
  
  if (detail) {
    formData.template_id = detail.id
    formData.template_name = detail.name
    
    loadTemplateStats(detail.id)
    
    // 初始化从机配置
     formData.data_sets =  selectedTemplateDetail.value.slaveInfos
      .filter((v, i, arr) => arr.findIndex(t => t.slave_id === v.slave_id) === i)
      .map(v => ({
        slave_id: v.slave_id,
        name: v.slave_name,
        serial_id: 1,
        slave_address: 1
      }))      

    //  ElMessage.error(`${formData.data_sets?.length} confirmTemplate`);
      
  }
  templateDialogVisible.value = false
}


// 在submitForm中确保提交从机配置
const submitForm = async () => {
  try {
    
    await formRef.value.validate()

    const submitData = {
      ...formData
    }

    emit('submit', submitData)
    return { success: true }
  } catch (error) {
    ElMessage.error('Form validation failed:', error);
    return { success: false, message: error.message }
  }
}
//监听字段变化
 watch(
      () => props.deviceData,(val) => {  
       // ElMessage.error(`watch 模板加载22`)
        if (val) {
          formData.value = { ...formData.value, ...val }          
          if (val.company_id) {
            formData.company_name = findCompanyName(
              val.company_id,
              companyTreeData.value
            )
          }
        }
      },
      { immediate: true, deep: true }
    )

// 监听选择的模板
watch(selectedTemplate, async (newVal) => {
  if (newVal) {    
    await loadTemplateDetail(newVal)
  } else {
    selectedTemplateDetail.value = null
    selectedTemplateVariables.value = []
  }
})

// 监听公司ID变化
watch(() => formData.company_id, (newVal) => {
  if (newVal && templateDialogVisible.value) {
    loadTemplates()
  }
})

// 暴露方法
defineExpose({
  submitForm
})

// 初始化
onMounted(async () => {
  await loadCompanyTree()
  await loadGateways()
  await initFormData()  
})
</script>

<style scoped>
.template-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.template-card {
  width: 100%;
}

.template-card-content {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.template-name {
  font-weight: bold;
  margin-bottom: 5px;
}

.template-stats {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #606266;
}

.stat-item {
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.stat-label {
  color: #606266;
  margin-right: 10px;
}

.stat-value {
  font-weight: bold;
}


.template-detail {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid var(--el-border-color);
  border-radius: 4px;
}

.slave-config-container {
  margin-top: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
}

.slave-config-item {
  padding: 10px 0;
  border-bottom: 1px dashed #ebeef5;
}

.slave-config-item:last-child {
  border-bottom: none;
}

.data-settings-card {
  margin-bottom: 20px;
  border: 1px solid var(--el-border-color);
  border-radius: 4px;
  background-color: var(--el-bg-color);
}

.card-header {
  padding: 12px 16px;
  background-color: var(--el-bg-color-overlay);
  border-bottom: 1px solid var(--el-border-color);
  font-weight: 500;
}

.card-content {
  padding: 16px;
}

.template-name-display {
  margin-left: 10px;
  margin-right: 20px;
  font-weight: 500;
}

.slave-config-container {
  margin-top: 15px;
  border: 1px solid var(--el-border-color-light);
  border-radius: 4px;
  background-color: var(--el-bg-color-page);
}

.slave-config-header {
  padding: 10px 15px;
  background-color: var(--el-bg-color-overlay);
  border-bottom: 1px solid var(--el-border-color-light);
  font-size: 14px;
}

.slave-config-item {
  padding: 12px 0;
  border-bottom: 1px dashed var(--el-border-color-light);
}

.slave-config-item:last-child {
  border-bottom: none;
}

/* 从机配置滑动条样式 */
.slave-config-wrapper {
  margin-top: 20px;
  max-height: 300px; /* 设置最大高度 */
  overflow-y: auto;  /* 垂直滚动条 */
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.slave-config-container {
  min-height: 100px; /* 最小高度 */
}

/* 滚动条美化 */
.slave-config-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.slave-config-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.slave-config-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 3px;
}

.slave-config-item {
  padding: 15px;
  border-bottom: 1px dashed #ebeef5;
}

.slave-config-item:last-child {
  border-bottom: none;
}

.slave-config-header {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 15px;
  background-color: #fafafa;
  border-bottom: 1px solid #ebeef5;
  font-weight: 500;
}
</style>